export const EVENT_CATEGORIES: Transformed.EventCategory[] = [
  'Music',
  'Community',
  'Workshops',
]

export const DESCRIPTION_CHAR_LIMIT = 500
export const EVENT_DESCRIPTION_SELECTOR = '#event-description'
export const ADVANCED_FILTERING_ENABLED = false

/** Kill switch for the "events when you visit" widget on the purchase confirmation pages. */
export const EVENTS_DURING_VISIT_ENABLED = true
/** How many calendar days either side of the visit date count as "when you visit". */
export const EVENTS_DURING_VISIT_WINDOW_DAYS = 3
/** Most event cards the confirmation widget will promote. */
export const EVENTS_DURING_VISIT_MAX_CARDS = 6

export enum EventMod {
  Upcoming = 0,
  RecentlyAnnounced = 1,
}

export enum EventCardVariant {
  Default = 'default',
  Compact = 'compact',
}
